import React from "react";
import { Grid } from "@mui/material";
import ProductInfo from "./ProductInfo";
import ImageSwipper from "./ImageGallery";

const Detail = ({ productDetail }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        {productDetail?.galleryImages?.length > 0 && (
          <ImageSwipper galleryImages={productDetail?.galleryImages} />
        )}
      </Grid>
      <Grid item xs={12} md={5}>
        <ProductInfo productDetail={productDetail} />
      </Grid>
    </Grid>
  );
};

export default Detail;
